export default __webpack_public_path__ + "static/media/ic_clock@3x.919df462.png";